import { validate } from "com";
import { USER_ENDPOINTS } from "./endpoints";
import type { RequestEmailChangePayload, RequestEmailChangeResponse } from "./types";
import { apiPost } from "../shared";

export default async function requestEmailChange(
  currentPassword: string,
  newEmail: string
): Promise<RequestEmailChangeResponse> {
  validate.password(currentPassword, "Current password");
  validate.email(newEmail, "New email");

  const payload: RequestEmailChangePayload = { currentPassword, newEmail };
  return apiPost<RequestEmailChangeResponse>(USER_ENDPOINTS.REQUEST_EMAIL_CHANGE, payload);
}
